module.exports = __webpack_public_path__ + "static/media/product.728b0e76.jpg";